var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIconMobileCrmGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76074 12.2396C8.12572 12.6121 8.56136 12.908 9.04214 13.11C9.52292 13.3121 10.0392 13.4161 10.5607 13.4161C11.0822 13.4161 11.5984 13.3121 12.0792 13.11C12.56 12.908 12.9957 12.6121 13.3606 12.2396L17.8405 7.75966C18.5831 7.01707 19.0003 6.0099 19.0003 4.95972C19.0003 3.90954 18.5831 2.90237 17.8405 2.15977C17.0979 1.41718 16.0908 1 15.0406 1C13.9904 1 12.9832 1.41718 12.2407 2.15977L11.6807 2.71976",
    stroke: "#5F6787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2396 7.75858C11.8746 7.38608 11.439 7.09015 10.9582 6.88812C10.4774 6.68609 9.96113 6.58203 9.43963 6.58203C8.91812 6.58203 8.40186 6.68609 7.92108 6.88812C7.4403 7.09015 7.00466 7.38608 6.63968 7.75858L2.15977 12.2385C1.41718 12.9811 1 13.9882 1 15.0384C1 16.0886 1.41718 17.0958 2.15977 17.8384C2.90237 18.581 3.90953 18.9981 4.95972 18.9981C6.0099 18.9981 7.01707 18.581 7.75966 17.8384L8.31965 17.2784",
    stroke: "#5F6787",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconMobileCrmGray);
export default __webpack_public_path__ + "static/media/copy-icon-mobile-crm-gray.91300517de59e76f086d3e4e194066fc.svg";
export { ForwardRef as ReactComponent };